<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Ansatte</h4>
      </div>

      <TheSelectInput v-model="filter.status" containerClassName="cell shrink" :items="filters"/>
    </div>

    <router-link :to="{ name: 'BrukerCardAdd' }" class="button action fixed right glyph">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg>
      <span>Ny Ansatt</span>
    </router-link>

    <TheLoader :active="loading"/>
    <TheEmptyList v-if="!loading && filteredItems.length < 1" :title="'Ingen ansatte'"  :large="true" :icon="'glyph-medium-object'"/>
    <table v-if="!loading && filteredItems.length > 0" class="large fixed clickable visible" style="width: 100%">
      <thead>
        <tr>
          <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === sortKey ? sortClass : '']" @click="sortBy(heading.sortKey)">
            {{heading.name}}
            <span id="sorttable_sortrevind" v-if="heading.sortKey === sortKey && reverse">&nbsp;</span>
            <span id="sorttable_sortfwdind" v-if="heading.sortKey === sortKey && !reverse">&nbsp;</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filteredItems" v-bind:key="item.Kundenr" @click="onBrukerClick(item)">
          <td>
            <span class="icon-container">
              <span class="avatar small icon">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg>
              </span>
              <a href="javascript:;" class="primary-title">{{item.Brukerid}}</a>
            </span>
          </td>
          <td>{{item.Brukernavn}}</td>
          <td>{{item.full_name}}</td>
          <td>{{item.rolle ? item.rolle.name : '-'}}</td>
          <td>{{item.avdeling ? item.avdeling.Beskrivelse : '-'}}</td>
          <td class="align-right">{{item.Inaktiv === 'F' ? 'Nei' : 'Ja'}}</td>
          <td class="align-right">
            <span class="avatar name left" :class="strToAvatarClass(item.initials)">
              {{item.initials}}
              <span class="name">{{item.full_name}}</span>
            </span>
          </td>
          <td class="align-right">
            <span v-if="item.twentyfourseven_id_web_auction" class="avatar name left green">NA <span class="name">Synkronisert med 247 nett</span></span>
            <span v-else class="avatar name left red">NA <span class="name">Ikke synkronisert med 247 nett</span></span>
            &nbsp;
            <span v-if="item.twentyfourseven_id_art_trade" class="avatar name left green">KH <span class="name">Synkronisert med 247 kunst</span></span>
            <span v-else class="avatar name left red">KH <span class="name">Ikke synkronisert med 247 kunst</span></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BrukerService from '@/services/BrukerService'

export default {
  name: 'BrukerList',
  data () {
    return {
      items: [],
      filter: {
        status: null
      },
      filters: [
        { key: null, val: 'Alle' },
        { key: 'F', val: 'Aktive' },
        { key: 'T', val: 'Inaktive' }
      ],
      loading: false,
      headings: [
        {name: 'Brukerid', sortKey: 'Brukerid', class: ''},
        {name: 'Brukernavn', sortKey: 'Brukernavn', class: ''},
        {name: 'Navn', sortKey: 'full_name', class: ''},
        {name: 'Rolle', sortKey: 'rolle.name', class: ''},
        {name: 'Avdeling', sortKey: 'avdeling.Beskrivelse', class: ''},
        {name: 'Inaktiv', sortKey: 'Inaktiv', class: 'align-right'},
        {name: 'Bruker', sortKey: 'initials', class: 'align-right'},
        {name: '247 Synkronisert', sortKey: '', class: 'align-right'}
      ],
      sortKey: 'Brukerid',
      reverse: false
    }
  },
  // When component is created - set page
  created () {
    this.loadFilter()

    this.fetch()
  },
  computed: {
    filteredItems: function () {
      if (!this.filter.status) {
        return this._.orderBy(this.items, this.sortKey, this.reverse ? 'desc' : 'asc')
      }

      let items = this.items.filter(i => i.Inaktiv === this.filter.status)

      return this._.orderBy(items, this.sortKey, this.reverse ? 'desc' : 'asc')
    },
    sortClass: function () {
      return 'sorttable_sorted' + (this.reverse ? '_reverse' : '')
    }
  },
  watch: {
    'filter.status': function (newVal) {
      if (newVal !== undefined) {
        this.saveFilter()
      }
    }
  },
  methods: {
    loadFilter: function () {
      try {
        this.filter = JSON.parse(localStorage.brukerlist_filter)
      } catch (e) {
        this.filter = {
          status: null
        }
      }
    },
    saveFilter: function () {
      localStorage.brukerlist_filter = JSON.stringify(this.filter)
    },
    fetch: function () {
      this.loading = true

      BrukerService.index()
        .then((response) => {
          this.items = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke laste inn bruker')
        })
        .then(() => {
          this.loading = false
        })
    },
    onBrukerClick: function (item) {
      this.$router.push({name: 'BrukerCard', params: {bruker_id: item.Brukerid}})
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
      this.sortKey = sortKey
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BrukerList.vue